import React from "react";
import Shabash from "../../../../assets/svgs/gameplay/Shabash";
import { getWidth } from "../../../../utils/relativeSizes";
import CommonAnimation from "./CommonAnimation";

const ShabashAnimation = () => {

  return (
    <CommonAnimation>
      <Shabash width={getWidth(125)} height={getWidth(46)} />
    </CommonAnimation>
  );
};

export default ShabashAnimation;
